import { FunctionComponent as FC } from 'react';

import { withStyles, Modal, Card, Icon, InteracWordmark } from 'vopay';
import styles from './AddInteracModal.module.scss';
import { Button, Title } from 'UI';
import { useForm } from '@/components/Form/utils';
import useFormConfig, { initialValues, FormValues } from './buildFormConfig';
import { useTranslation, Trans } from 'react-i18next';

const classes = withStyles(styles);

type AddInteracModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (values: FormValues) => Promise<void>;
};

const AddInteracModal: FC<AddInteracModalProps> = ({ isOpen, onClose, onSubmit }) => {
  const config = useFormConfig();
  const { t } = useTranslation('translations', { keyPrefix: 'Customers.PaymentMethodsTab.AddInteracModal' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const { renderFormElements, ctx } = useForm<FormValues, FormValues>({
    initialValues,
    config,
    onSubmit: async (values, { resetForm }) => {
      await onSubmit(values);
      resetForm();
    },
  });

  return (
    <Modal isVisible={isOpen} enableBgClick={false}>
      <Card data-testid="addInteracCard" className={classes('addInteracContainer')}>
        <Title level="4" style={{ textAlign: 'center' }}>
          <Trans
            ns="translations"
            i18nKey="Customers.PaymentMethodsTab.AddInteracModal.title"
            components={{
              InteracWordmark: <InteracWordmark />,
            }}
          />
        </Title>

        <form onSubmit={ctx.handleSubmit}>
          {renderFormElements({ config })}

          <div className={classes('buttons')}>
            <Button onClick={onClose} disabled={ctx.isSubmitting}>
              {tGlobal('Buttons.cancel', { defaultValue: 'Cancel' })}
            </Button>

            <Button type="submit" colorScheme="primary" disabled={!ctx.isValid || ctx.isSubmitting}>
              {ctx.isSubmitting ? (
                <Icon icon="loader" height="40px" width="40px" />
              ) : (
                t('submit', { defaultValue: 'Payment Method' })
              )}
            </Button>
          </div>
        </form>
      </Card>
    </Modal>
  );
};

export default AddInteracModal;
